// utils/branding.js
// Single source of truth for company branding (logo, shop name, contact lines).
// Reused by the sidebar, the top bar, and every printed document (receipts / bills /
// invoices).
//
// CM_Logo / CM_ProfilePic hold the RELATIVE upload path returned by uploadAPI.image
// (e.g. "uploads/company/12/logo_ab12cd.jpg"). resolveImageUrl() turns that into an
// ABSOLUTE URL, which matters for ReceiptModal: it writes its HTML into a blank
// window.open document, where a relative path has no base to resolve against.
// Legacy rows that still hold a base64 data URL pass through untouched, so companies
// saved before the cPanel upload endpoint existed keep rendering with no migration.
import fallbackLogo from "../../assets/logo.png";

const BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

export function resolveImageUrl(value) {
  const v = typeof value === "string" ? value.trim() : "";
  if (!v) return null;
  if (v.startsWith("data:")) return v;                     // legacy inline image
  if (/^https?:\/\//i.test(v)) return v;                   // already absolute
  return `${BASE_URL.replace(/\/+$/, "")}/${v.replace(/^\/+/, "")}`;
}

export function getBranding(company) {
  return {
    shopName:   company?.CM_Name       || "Tailor Expert",
    logoSrc:    resolveImageUrl(company?.CM_Logo) || fallbackLogo, // uploaded logo wins; bundled asset is fallback
    profilePic: resolveImageUrl(company?.CM_ProfilePic),
    address:    company?.CM_Address    || "",
    city:       company?.CM_City       || "",
    contact:    company?.CM_ContactNo  || "",
    email:      company?.CM_Email      || "",
  };
}
